<div *ngIf="status" class="status-label status-label-{{ status }}">
  <div class="status-label-circle status-label-circle-{{ status }}"></div>
  {{ getTitle() }}
</div>
